/** Retry connectivity failures, but leave HTTP auth/validation conflicts for resolution. */
export function shouldRetryQueue(result: {remaining:number;blocked:{lastError?:string}|null}):boolean {
  return result.remaining>0 && (!result.blocked || Boolean(result.blocked.lastError&&!/^\d{3}\s/.test(result.blocked.lastError)));
}
